import CityPageTemplate from "../city-template/CityPageTemplate";
import { austinConfig } from "./data";

export default function AustinPage() {
  return <CityPageTemplate config={austinConfig} />;
}